import { createSlice } from "@reduxjs/toolkit";
import { getDetailedSiteAnalyticsBuilder } from "./builder";

const initialState = {
  detailedSiteAnalytics: {
    data: [],
    loading: false,
    error: null,
  },
};

export const analyticsSlice = createSlice({
  name: "analyticsInfo",
  initialState,
  reducers: {
    clearDetailedSiteAnalyticsError: (state) => {
      state.detailedSiteAnalytics.error = null;
    },
  },

  extraReducers: (builder) => {
    getDetailedSiteAnalyticsBuilder(builder);
    // Handle logout
    builder.addCase("auth/logout", (state) => {});
  },
});

export const { clearDetailedSiteAnalyticsError } = analyticsSlice.actions;

// Selectors
export const selectDetailedSiteAnalytics = (state) =>
  state.analyticsInfo.detailedSiteAnalytics;

export default analyticsSlice.reducer;
